import React, { Fragment } from "react";
import FormControl from "@material-ui/core/FormControl";
import { InputLabel, MenuItem } from "@material-ui/core";
import Select from "@material-ui/core/Select";
import { Skeleton } from "@material-ui/lab";
import { useCountries } from "../cspServices";

const CountrySelect = props => {
  const { onChange, value } = props;
  const countries = useCountries();

  return (
    <Fragment>
      {countries.isLoading ? (
        <Skeleton variant="text" />
      ) : (
        <FormControl fullWidth>
          <InputLabel htmlFor="content-audience">Country</InputLabel>
          <Select
            value={value || ""}
            onChange={onChange}
            inputProps={{
              name: "country",
              id: "country",
            }}
          >
            {countries.data.map(country => {
              return (
                <MenuItem value={country.code} key={country.code}>
                  {country.name}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
      )}
    </Fragment>
  );
};

export default CountrySelect;
